"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsLoginSuccess = exports.selectRedirectAfterLogin = exports.selectLoginModalIsOpen = exports.selectLoginIsLoading = exports.logout = exports.loginUser = exports.logoutSuccess = exports.closeLoginFormModal = exports.openLoginFormModal = exports.loginFailed = exports.loginSuccess = exports.loginAttempt = exports.loginSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var auth = __importStar(require("../../helpers/auth"));
var auth_header_1 = require("../../api/auth-header");
var userSlice_1 = require("../user/userSlice");
var initialState = {
    loading: false,
    errors: false,
    modal: {
        open: false,
        redirectAfterLogin: true,
    },
    token: auth.getToken(),
    isLoginSuccess: false,
};
exports.loginSlice = toolkit_1.createSlice({
    name: 'login',
    initialState: initialState,
    reducers: {
        loginAttempt: function (state) {
            state.loading = true;
            state.errors = false;
            state.isLoginSuccess = false;
        },
        loginSuccess: function (state, action) {
            state.loading = false;
            state.errors = false;
            state.token = action.payload.token;
            state.isLoginSuccess = true;
        },
        loginFailed: function (state, action) {
            state.loading = false;
            state.isLoginSuccess = false;
            state.errors = action.payload.errors;
        },
        logoutSuccess: function (state) {
            state.loading = false;
            state.errors = false;
            state.token = null;
        },
        openLoginFormModal: function (state, action) {
            state.modal.open = true;
            state.modal.redirectAfterLogin = action.payload.redirectAfterLogin;
        },
        closeLoginFormModal: function (state) {
            state.modal.open = false;
            state.loading = false;
        },
    },
});
exports.loginAttempt = (_a = exports.loginSlice.actions, _a.loginAttempt), exports.loginSuccess = _a.loginSuccess, exports.loginFailed = _a.loginFailed, exports.openLoginFormModal = _a.openLoginFormModal, exports.closeLoginFormModal = _a.closeLoginFormModal, exports.logoutSuccess = _a.logoutSuccess;
var loginUser = function (formValues) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, token, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.loginAttempt());
                    return [4 /*yield*/, axios_1.default.post('/api/login', formValues)];
                case 1:
                    response = _a.sent();
                    token = response.data.access_token;
                    auth.setToken(token);
                    dispatch(exports.loginSuccess({ token: token }));
                    dispatch(exports.closeLoginFormModal());
                    return [2 /*return*/, response.data];
                case 2:
                    e_1 = _a.sent();
                    if (e_1.response.status === 406) {
                        dispatch(exports.closeLoginFormModal());
                        auth.setUnverifiedEmail(formValues.email);
                    }
                    else {
                        dispatch(exports.loginFailed({ errors: e_1.response.data.error }));
                    }
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.loginUser = loginUser;
var logout = function () {
    return function (dispatch) {
        try {
            axios_1.default.post('/api/logout', null, {
                headers: {
                    Authorization: auth_header_1.getBearer(),
                },
            });
            auth.removeToken();
            auth.removeIsFavoriteUser();
            dispatch(userSlice_1.removeUser());
            dispatch(exports.logoutSuccess());
        }
        catch (e) {
            throw e;
        }
    };
};
exports.logout = logout;
var selectLoginIsLoading = function (state) { return state.login.loading; };
exports.selectLoginIsLoading = selectLoginIsLoading;
var selectLoginModalIsOpen = function (state) {
    return state.login.modal.open;
};
exports.selectLoginModalIsOpen = selectLoginModalIsOpen;
var selectRedirectAfterLogin = function (state) {
    return state.login.modal.redirectAfterLogin;
};
exports.selectRedirectAfterLogin = selectRedirectAfterLogin;
var selectIsLoginSuccess = function (state) {
    return state.login.isLoginSuccess;
};
exports.selectIsLoginSuccess = selectIsLoginSuccess;
exports.default = exports.loginSlice.reducer;
